import React from "react";
import { Section, SectionHeading, Reveal } from "./Primitives";
import { WHY } from "../../data/content";

export const WhyBuildRaq = () => {
  return (
    <Section id="why">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5 lg:sticky lg:top-28 lg:self-start">
          <SectionHeading overline={WHY.overline} title={WHY.title} />
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/5 rounded-3xl overflow-hidden border border-white/5">
          {WHY.items.map((w, i) => {
            const Icon = w.icon;
            return (
              <Reveal
                key={w.title}
                delay={(i % 2) * 0.08}
                className="group bg-void hover:bg-white/[0.02] transition-colors duration-300 p-8"
              >
                <div className="flex items-center justify-between mb-6">
                  <Icon className="h-6 w-6 text-brand" strokeWidth={1.6} />
                  <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
                    {w.kpi}
                  </span>
                </div>
                <h3 className="font-heading text-lg font-medium text-white">{w.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{w.body}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </Section>
  );
};

export default WhyBuildRaq;
